import { render, staticRenderFns } from "./CatalogPage.vue?vue&type=template&id=d17d7464&"
import script from "./CatalogPage.vue?vue&type=script&lang=js&"
export * from "./CatalogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports